module.exports = __webpack_public_path__ + "img/photo.61177e0a.svg";